// extracted by mini-css-extract-plugin
export var printerCard = "_ay-1";
export var printerCardConfigured = "_ay-2";
export var printerCardError = "_ay-3";
export var printerCardsContainer = "_ay-0";
export var printerIcon = "_ay-8";
export var printerIconConfigured = "_ay-5";
export var printerIconContainer = "_ay-4";
export var printerIconError = "_ay-6";
export var printerIconUnconfigured = "_ay-7";
export var workstationsTableCard = "_ay-9";